import React, { useEffect, useRef } from 'react'
import { MapContainer, TileLayer, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import L from 'leaflet'
import 'leaflet.markercluster'

// ─── SVG IKONŲ KELIAI (mini versijos pin'ų viduje) ───────────────────────────
// Spalva visada #141F1A (tamsi ant gintaro fono)

const PINU_IKONOS_SVG = {
  gamta: `<path d="M12 22V12M12 12c-3-4-8-3-8-8 4 0 6 2 8 4 2-2 4-4 8-4 0 5-5 4-8 8z" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round" fill="none"/>`,

  jura: `
    <path d="M2 15c2-2 4-2 6 0s4 2 6 0 4-2 6 0" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" fill="none"/>
    <path d="M2 11c2-2 4-2 6 0s4 2 6 0 4-2 6 0" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" fill="none"/>
    <circle cx="19" cy="6" r="2" fill="#141F1A" stroke="none"/>`,

  istorija: `<path d="M4 21V9l8-6 8 6v12" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M9 21v-8h6v8" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round" fill="none"/>`,

  miestas: `
    <path d="M3 20.7h18" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round"/>
    <path d="M5 20.5V12l3-2 3 2v8.5" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M11 20.5V5.5l4-0.8 4 2.8v13" stroke="#141F1A" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round" fill="none"/>`,

  vaikams: `
    <circle cx="8" cy="6" r="2.1" stroke="#141F1A" stroke-width="1.85" fill="none"/>
    <path d="M8 8.5c-2.1 0.15-3.3 2.1-3.3 4.6V17c0 0.6 0.4 1 1 1h4.6c0.6 0 1-0.4 1-1v-4c0-2.55-1.25-4.35-3.3-4.5z" stroke="#141F1A" stroke-width="1.85" fill="none"/>
    <circle cx="15.5" cy="9" r="1.5" stroke="#141F1A" stroke-width="1.85" fill="none"/>
    <path d="M15.5 10.9c-1.4 0.12-2.35 1.4-2.35 3.15V17c0 0.6 0.4 1 1 1h2.7c0.6 0 1-0.4 1-1v-3c0-1.75-0.95-3.05-2.35-3.1z" stroke="#141F1A" stroke-width="1.85" fill="none"/>`,
}

// ─── PIN KŪRIMO FUNKCIJOS ─────────────────────────────────────────────────────

// Vietos pin — gintaro apskritimas su kategorijos ikona
function sukurtiVietosPin(kategorija, aktyvus = false) {
  const dydis = aktyvus ? 32 : 24
  const radius = dydis / 2
  const ikona = PINU_IKONOS_SVG[kategorija] || PINU_IKONOS_SVG.gamta
  const glow = aktyvus
    ? `<circle cx="${radius}" cy="${radius}" r="${radius + 6}" fill="rgba(229,168,64,0.28)"/>`
    : ''

  return L.divIcon({
    className: '',
    html: `
      <svg width="${dydis}" height="${dydis}" viewBox="0 0 ${dydis} ${dydis}" xmlns="http://www.w3.org/2000/svg">
        ${glow}
        <circle cx="${radius}" cy="${radius}" r="${radius}" fill="#E5A840"/>
        <g transform="translate(${radius - 7}, ${radius - 7}) scale(0.58)">
          ${ikona}
        </g>
      </svg>`,
    iconSize: [dydis, dydis],
    iconAnchor: [radius, radius],
  })
}

// Filtro neaktyvus pin — mažas pilkas taškas
function sukurtiPilkaTaska() {
  return L.divIcon({
    className: '',
    html: `<svg width="8" height="8" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="4" fill="#5A6558" opacity="0.55"/>
    </svg>`,
    iconSize: [8, 8],
    iconAnchor: [4, 4],
  })
}

// Prisiminimo pin — nuotraukos miniatiūra su gintaro apvadu (+ skaičius, jei kelios)
function sukurtiNuotraukosPin(dataUrl, count) {
  const badge = count > 1
    ? `<div style="position:absolute;top:-5px;right:-5px;min-width:17px;height:17px;padding:0 4px;border-radius:9px;background:#E5A840;color:#141F1A;font:600 10px Syne,system-ui,sans-serif;display:flex;align-items:center;justify-content:center;border:1.5px solid #141F1A;box-sizing:border-box;">${count}</div>`
    : ''
  return L.divIcon({
    className: '',
    html: `<div style="position:relative;width:46px;height:46px;">
      <div style="width:46px;height:46px;border-radius:11px;overflow:hidden;border:2px solid #E5A840;box-shadow:0 2px 10px rgba(0,0,0,0.55);background:#1E2E27;">
        <img src="${dataUrl}" alt="" style="width:100%;height:100%;object-fit:cover;display:block;"/>
      </div>${badge}
    </div>`,
    iconSize: [46, 46],
    iconAnchor: [23, 23],
  })
}

// Vartotojo pin — baltas su gintaro apvadu ir pulsavimo animacija
function sukurtiVartotojoPin() {
  return L.divIcon({
    className: 'vartotojo-pin-konteineris',
    html: `
      <div class="vartotojo-pin">
        <div class="vartotojo-pin-glow"></div>
        <div class="vartotojo-pin-vidus"></div>
      </div>`,
    iconSize: [36, 36],
    iconAnchor: [18, 18],
  })
}

// ─── CLUSTER STILIAI ──────────────────────────────────────────────────────────

function sukurtiClusterGrupa() {
  return L.markerClusterGroup({
    maxClusterRadius: 50,
    iconCreateFunction: (cluster) => {
      const skaicius = cluster.getChildCount()
      let dydis, fontSize

      if (skaicius < 10) {
        dydis = 30; fontSize = 12
      } else if (skaicius < 50) {
        dydis = 36; fontSize = 13
      } else {
        dydis = 44; fontSize = 14
      }

      const tekstas = skaicius > 99 ? '99+' : skaicius
      const radius = dydis / 2

      return L.divIcon({
        className: '',
        html: `
          <svg width="${dydis}" height="${dydis}" viewBox="0 0 ${dydis} ${dydis}" xmlns="http://www.w3.org/2000/svg">
            <circle cx="${radius}" cy="${radius}" r="${radius}" fill="rgba(229,168,64,0.15)"/>
            <circle cx="${radius}" cy="${radius}" r="${radius - 4}" fill="#E5A840"/>
            <text x="${radius}" y="${radius + fontSize * 0.35}" text-anchor="middle"
              font-family="Syne, system-ui, sans-serif"
              font-size="${fontSize}"
              font-weight="600"
              fill="#141F1A">${tekstas}</text>
          </svg>`,
        iconSize: [dydis, dydis],
        iconAnchor: [radius, radius],
      })
    },
  })
}

// ─── ŽEMĖLAPIO TURINIO KOMPONENTAS ───────────────────────────────────────────
// (vidinis komponentas — turi prieigą prie Leaflet map per useMap)

function ZemelapisTurinys({ vietos, lokacija, pasirinkta, aktyviosKategorijos, onVietaPasirinkta, pradiniscentras, pinPozicija = 0.5, piestiLinija = true, centruotiSignalas = 0, fitRibos = null, aplankytiIds = null, fitApacia = 0, visaLietuva = false, prisiminimuTaskai = null, onPrisiminimas = null }) {
  const map = useMap()

  useEffect(() => {
    if (pradiniscentras) {
      const offsetLat = pradiniscentras.lat + 0.004
      map.setView([offsetLat, pradiniscentras.lng], 13, { animate: false })
      map.zoomControl?.remove()
    } else {
      map.zoomControl?.addTo(map)
    }
  }, [pradiniscentras, map])
  const clusterRef = useRef(null)
  const vartotojasPinRef = useRef(null)
  const punktyrineLinija = useRef(null)
  const centruotaRef = useRef(false)

  // ── Centravimas ant vartotojo lokacijos ──
  // pinPozicija = kurioje ekrano vietoje (nuo viršaus, 0–1) turi būti pin'as.
  // Kai lentelė viršuje — 0.22 (matomoje juostoje virš jos).
  // Kai lentelė nuleista — 0.5 (žemėlapio viduryje).
  // Perskaičiuoja kai keičiasi lentelės būsena; tarp perjungimų vartotojo
  // slankiojimas nepaliečiamas.
  useEffect(() => {
    if (pradiniscentras) return
    if (!lokacija) return
    const pirmas = !centruotaRef.current
    const zoom = pirmas ? 12 : map.getZoom()
    // Deterministiškai apskaičiuojam centrą, kad taškiukas atsidurtų būtent
    // ties pinPozicija (dalis nuo viršaus). project/unproject — be panBy krypties spėlionių.
    const dydis = map.getSize()
    const taskas = map.project([lokacija.lat, lokacija.lng], zoom)
    const centras = map.unproject(
      L.point(taskas.x, taskas.y + (0.5 - pinPozicija) * dydis.y),
      zoom
    )
    map.setView(centras, zoom, { animate: !pirmas })
    centruotaRef.current = true
    // pinPozicija sąmoningai NE priklausomybėse — nenorim persicentruoti
    // keičiant lentelės būseną; centruojam tik užsikrovus ir per locate mygtuką.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, lokacija, pradiniscentras, centruotiSignalas])

  // ── Priartinam prie paieškos rezultatų (fitBounds) ──
  useEffect(() => {
    if (!fitRibos || fitRibos.length === 0) return
    const apacia = fitApacia || 80
    // Paieškoje — rodom visą Lietuvą (kad matytųsi visi pin'ai, ne tik dalis)
    if (visaLietuva) {
      const LT = L.latLngBounds([[53.89, 20.95], [56.45, 26.9]])
      map.fitBounds(LT, { paddingTopLeft: [16, 88], paddingBottomRight: [16, apacia], maxZoom: 9, animate: true })
      return
    }
    const taskai = fitRibos
      .filter(v => v.latitude && v.longitude)
      .map(v => [v.latitude, v.longitude])
    if (taskai.length === 0) return
    if (taskai.length === 1) {
      // Vieną tašką dedam į matomą viršutinę juostą (virš lentelės)
      const dydis = map.getSize()
      const laisva = Math.max(0, dydis.y - apacia - 100)
      const p = map.project(taskai[0], 13)
      const c = map.unproject(L.point(p.x, p.y + ((dydis.y / 2) - (100 + laisva / 2))), 13)
      map.setView(c, 13, { animate: true })
    } else {
      map.fitBounds(L.latLngBounds(taskai), { paddingTopLeft: [40, 100], paddingBottomRight: [40, apacia], maxZoom: 13, animate: true })
    }
  }, [map, fitRibos, fitApacia, visaLietuva])

  // ── Vartotojo pin ──
  useEffect(() => {
    if (!lokacija) return

    if (vartotojasPinRef.current) {
      map.removeLayer(vartotojasPinRef.current)
    }

    vartotojasPinRef.current = L.marker(
      [lokacija.lat, lokacija.lng],
      { icon: sukurtiVartotojoPin(), zIndexOffset: 1000 }
    ).addTo(map)

    return () => {
      if (vartotojasPinRef.current) {
        map.removeLayer(vartotojasPinRef.current)
      }
    }
  }, [map, lokacija])

  // ── Punktyrinė linija ──
  useEffect(() => {
    if (punktyrineLinija.current) {
      map.removeLayer(punktyrineLinija.current)
      punktyrineLinija.current = null
    }

    if (pasirinkta && lokacija && piestiLinija) {
      punktyrineLinija.current = L.polyline(
        [
          [lokacija.lat, lokacija.lng],
          [pasirinkta.latitude, pasirinkta.longitude],
        ],
        {
          color: '#E5A840',
          weight: 2,
          dashArray: '4, 6',
          opacity: 0.8,
        }
      ).addTo(map)
    }

    return () => {
      if (punktyrineLinija.current) {
        map.removeLayer(punktyrineLinija.current)
      }
    }
  }, [map, pasirinkta, lokacija, piestiLinija])

  // ── Prisiminimų (nuotraukų) markeriai ──
  useEffect(() => {
    if (!prisiminimuTaskai || prisiminimuTaskai.length === 0) return
    const markeriai = prisiminimuTaskai
      .filter(g => g.lat != null && g.lng != null && g.dataUrl)
      .map(g => {
        const m = L.marker([g.lat, g.lng], { icon: sukurtiNuotraukosPin(g.dataUrl, g.count), zIndexOffset: 600 })
        m.on('click', (ev) => {
          if (ev.originalEvent) L.DomEvent.stopPropagation(ev.originalEvent)
          if (onPrisiminimas) onPrisiminimas(g)
        })
        m.addTo(map)
        return m
      })
    return () => markeriai.forEach(m => map.removeLayer(m))
  }, [map, prisiminimuTaskai, onPrisiminimas])

  // ── Vietos pin'ai + cluster'iai ──
  useEffect(() => {
    // Valome seną cluster grupę
    if (clusterRef.current) {
      map.removeLayer(clusterRef.current)
    }

    const clusterGrupa = sukurtiClusterGrupa()

    vietos.forEach((vieta) => {
      // Ar vieta atitinka aktyvų filtrą?
      const aktyvus = pasirinkta && pasirinkta.id === vieta.id
      const atitinka = aplankytiIds
        ? aplankytiIds.has(vieta.id)
        : (!aktyviosKategorijos || aktyviosKategorijos.length === 0
          || aktyviosKategorijos.includes(vieta.kategorija))

      let ikona
      if (aktyvus) {
        ikona = sukurtiVietosPin(vieta.kategorija, true)
      } else if (!atitinka) {
        ikona = sukurtiPilkaTaska()
      } else {
        ikona = sukurtiVietosPin(vieta.kategorija, false)
      }

      const marker = L.marker([vieta.latitude, vieta.longitude], { icon: ikona })
      marker.on('click', (ev) => {
        // Stabdom, kad pin'o paspaudimas neprasimuštų iki žemėlapio konteinerio
        // onClick (kuris sutrauktų lentelę ir persicentruotų — blaškantis šuolis).
        if (ev.originalEvent) L.DomEvent.stopPropagation(ev.originalEvent)
        // Paspaudimo jutimas — impulsas ant pin'o ikonos (vidinis elementas,
        // kad nesikirstų su Leaflet pozicionavimo transform'u), tada atidarom.
        const el = marker.getElement()
        const vidus = el && el.firstElementChild
        if (vidus) {
          vidus.classList.remove('pin-paspaustas')
          void vidus.offsetWidth
          vidus.classList.add('pin-paspaustas')
        }
        // Centruojam paspaustą pin'ą (be priartinimo)
        map.panTo([vieta.latitude, vieta.longitude], { animate: true })
        setTimeout(() => onVietaPasirinkta(vieta), 190)
      })

      // Pilki taškai į cluster'ius nepatenka
      if (atitinka) {
        clusterGrupa.addLayer(marker)
      } else {
        marker.addTo(map)
      }
    })

    clusterGrupa.addTo(map)
    clusterRef.current = clusterGrupa

    return () => {
      if (clusterRef.current) {
        map.removeLayer(clusterRef.current)
      }
      // Pilki taškai jau pridėti tiesiogiai į map — reikia valyti
      map.eachLayer((layer) => {
        if (layer instanceof L.Marker && layer !== vartotojasPinRef.current) {
          if (!clusterRef.current?.hasLayer(layer)) {
            // Palieka — bus atnaujinta per sekantį useEffect
          }
        }
      })
    }
  }, [map, vietos, pasirinkta, aktyviosKategorijos, onVietaPasirinkta, aplankytiIds])

  return null
}

// ─── PAGRINDINIS KOMPONENTAS ──────────────────────────────────────────────────

function Zemelapis({ vietos, lokacija, onVietaPasirinkta, pasirinkta, aktyviosKategorijos, pradiniscentras, pinPozicija, piestiLinija, centruotiSignalas, fitRibos, aplankytiIds, fitApacia, visaLietuva, prisiminimuTaskai, onPrisiminimas }) {
  const centras = lokacija
    ? [lokacija.lat, lokacija.lng]
    : [55.1694, 23.8813] // Lietuvos centras

  return (
    <>
      {/* Vartotojo pin CSS animacija */}
      <style>{`
        .vartotojo-pin {
          width: 36px;
          height: 36px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .vartotojo-pin-glow {
          position: absolute;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(229,168,64,0.35) 0%, transparent 70%);
          animation: pinPulsavimas 2.4s ease-in-out infinite;
        }
        .vartotojo-pin-vidus {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #ffffff;
          border: 2.5px solid #E5A840;
          position: relative;
          z-index: 1;
        }
        @keyframes pinPulsavimas {
          0%, 100% { transform: scale(1); opacity: 1; }
          50%       { transform: scale(1.5); opacity: 0.4; }
        }

        /* Pin paspaudimo jutimas — trumpas „springtelėjimas" */
        .pin-paspaustas {
          transform-origin: center bottom;
          animation: pinPaspaustas 0.34s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes pinPaspaustas {
          0%   { transform: scale(1); }
          35%  { transform: scale(0.82); }
          70%  { transform: scale(1.28); }
          100% { transform: scale(1); }
        }

        /* Cluster'ių CSS override — slepiame default stilius */
        .leaflet-cluster-anim .leaflet-marker-icon,
        .leaflet-cluster-anim .leaflet-marker-shadow {
          transition: transform 0.3s ease-out, opacity 0.3s ease-in;
        }
        .marker-cluster {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }
        .marker-cluster div {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }
      `}</style>

      <MapContainer
        center={centras}
        zoom={10}
        style={{ height: '100%', width: '100%' }}
        zoomControl={true}
      >
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          maxZoom={19}
          attribution='&copy; Esri, Maxar, Earthstar Geographics'
        />
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}{r}.png"
          subdomains="abcd"
          maxZoom={20}
          attribution='&copy; <a href="https://carto.com/attributions">CARTO</a>'
        />

        <ZemelapisTurinys
          vietos={vietos}
          lokacija={lokacija}
          pasirinkta={pasirinkta}
          aktyviosKategorijos={aktyviosKategorijos}
          onVietaPasirinkta={onVietaPasirinkta}
          pradiniscentras={pradiniscentras}
          pinPozicija={pinPozicija}
          piestiLinija={piestiLinija}
          centruotiSignalas={centruotiSignalas}
          fitRibos={fitRibos}
          aplankytiIds={aplankytiIds}
          fitApacia={fitApacia}
          visaLietuva={visaLietuva}
          prisiminimuTaskai={prisiminimuTaskai}
          onPrisiminimas={onPrisiminimas}
        />
      </MapContainer>
    </>
  )
}

export default Zemelapis
